var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4 rounded shadow bg-white"},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"p-4 border-b border-gray-200 flex"},[_vm._t("header")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }